import * as React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function FBMonthYearPicker(props) {
  const {
    control,
    id,
    label,
    required,
    value = null,
    minDate = null,
    maxDate = null,
    disabled,
    readOnly,
    onChange: onInputChange,
    name,
  } = props;
  const [dateValue, setDateValue] = React.useState(value);

  const handleChange = (date, field) => {
    field.onChange(date);
    if (onInputChange) onInputChange(date);
  };

  const validate = (dt) => {
    try {
      const dtStr = dt.toISOString();
      return dtStr && dtStr !== "";
    } catch {
      return false;
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        control={control}
        name={id}
        rules={{
          required: { value: required, message: `${label} is required` },
          validate,
        }}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            label={label}
            required={required}
            value={dateValue}
            disabled={disabled}
            readOnly={readOnly}
            error={!!error}
            onChange={(newValue) => {
              setDateValue(newValue);
              handleChange(newValue, field);
            }}
            minDate={minDate}
            maxDate={maxDate}
            inputFormat="MM/yyyy"
            mask="__/____"
            disableMaskedInput={false}
            views={["year", "month"]}
            renderInput={(params) => (
              <TextField
                size="small"
                sx={{ "& legend": { width: "auto" } }}
                {...params}
                name={name}
              />
            )}
          />
        )}
      />
    </LocalizationProvider>
  );
}

FBMonthYearPicker.propTypes = {
  control: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, undefined]),
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

FBMonthYearPicker.defaultProps = {
  label: "",
  required: false,
  value: undefined,
  minDate: undefined,
  maxDate: undefined,
  disabled: false,
  readOnly: false,
  onChange: undefined,
};
